<div class="header p-lg-5">
	<div class="container d-lg-flex">
		<div class="d-flex justify-content-between align-items-center p-5">
			<div class="toggle-nav-main d-lg-none" (click)="toggleNavWrap()" [ngClass]="{'is-active': navWrapIsActive}"
				*ngIf="isAuthenticated">
				<span></span>
			</div>

			<a [routerLink]="[ '/projects' ]" class="logo" [ngClass]="{'is-active': navWrapIsActive}">
				<img src="assets/img/logo.svg" alt="">
			</a>

			<ifective-user [isAuthenticated]="isAuthenticated" class="d-lg-none" *ngIf="isAuthenticated"></ifective-user>
		</div>

		<div class="nav-wrap d-flex flex-column flex-lg-row flex-lg-grow-1" [ngClass]="{'is-active': navWrapIsActive}"
			*ngIf="isAuthenticated">

			<nav class="nav-main d-lg-flex">
				<a [routerLink]="[ '/projects' ]" routerLinkActive="active">Projecten</a>
				<a [routerLink]="[ '/tasks' ]" routerLinkActive="active" *ngIf="!isAdmin">Taken</a>
			</nav>

			<nav class="nav-main d-lg-flex" *ngIf="isAdmin">
				<a [routerLink]="[ '/reports' ]" routerLinkActive="active">Rapportage</a>
			</nav>
			<!-- <nav class="nav-main d-lg-flex" *ngIf="isAdmin">
				<a [routerLink]="[ '/admin' ]" routerLinkActive="active">Beheer</a>
			</nav> -->

			<ifective-user [isAuthenticated]="isAuthenticated" class="d-none d-lg-flex ml-lg-auto"></ifective-user>
		</div>
	</div>
</div>